import TextField from "@mui/material/TextField";

import { styled } from "@mui/material/styles";
const CssTextField = styled(TextField)({
  "& label": {
    color: "#fff",
  },
  "& label.Mui-focused": {
    color: "#fff",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "green",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#fff",
    },
    "&:hover fieldset": {
      borderColor: "#fff",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#fff",
    },
  },
});
const MyTextField = ({ label, type, onChange }) => {
  return (
    <CssTextField
      onChange={onChange}
      label={label}
      type={type}
      InputProps={{
        inputProps: {
          style: { textAlign: "center", color: "#fff" },
        },
      }}
    />
  );
};

export default MyTextField;
